import React from "react";

const ModalWrapper = ({ children, onClose, width = "modal-md" }) => (
  <div
    className="modal fade show d-block"
    style={{ background: "rgba(0,0,0,0.5)" }}
    onClick={onClose}
  >
    <div
      className={`modal-dialog modal-dialog-centered ${width}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-content p-4 rounded-4 border-0">
        {children}
      </div>
    </div>
  </div>
);

export default ModalWrapper;
